import { render, staticRenderFns } from "./DnsOverview.vue?vue&type=template&id=4fd38312&"
import script from "./DnsOverview.vue?vue&type=script&lang=js&"
export * from "./DnsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports